import TrombinoscopePreview from "@project/components/Trombinoscope/TrombinoscopePreview";
import ContentsTypes from "@shared/enums/contentsTypes";
import ContentsCustomTypes from "@project/enums/contentsCustomTypes.enum";
export const Trombinoscope = {
    label: "Trombinoscope - Bloc",
    type: ContentsCustomTypes.TROMBINOSCOPE,
    Preview: TrombinoscopePreview,
    icon: "user",
    editionModal: true,
    editionModalPosition: "top",
    children: [
        {
            label: "Première image",
            key: "image",
            type: ContentsTypes.IMAGE,
            value: "",
        },
        {
            label: "Deuxième image",
            key: "imageHover",
            type: ContentsTypes.IMAGE,
            value: "",
        },
        {
            label: "Nom",
            key: "name",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Prénom",
            key: "firstName",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Poste",
            key: "position",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Lien LinkedIn",
            key: "link",
            type: ContentsTypes.URL,
            value: "",
        },
        {
            label: "Couleur du texte",
            key: "textColor",
            type: ContentsTypes.COLOR,
            value: "#FFFFFF",
        },
        {
            label: "Couleur du texte au survol",
            key: "textColorHover",
            type: ContentsTypes.COLOR,
            value: "#27272B",
        },
        {
            label: "Couleur de fond",
            key: "backgroundColor",
            type: ContentsTypes.COLOR,
            value: "#0000FF",
        },
        {
            label: "Couleur de fond au survol",
            key: "backgroundColorHover",
            type: ContentsTypes.COLOR,
            value: "#FFFF80",
        },
    ],
};
